import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// Función auxiliar para obtener una cookie por nombre
const getCookie = (name) => {
   const value = `; ${document.cookie}`;
   const parts = value.split(`; ${name}=`);
   if (parts.length === 2) return parts.pop().split(';').shift();
   return null;
};

const useAuthRedirect = (redirectTo = '/dashboard') => {
   const navigate = useNavigate();

   useEffect(() => {
      const jwt = getCookie('jwt');
      if (jwt) {
         try {
            const payload = JSON.parse(atob(jwt.split('.')[1]));
            const currentTime = Date.now() / 1000;

            if (payload.exp > currentTime) {
               navigate(redirectTo);
            } else {
               // Token expirado, limpiar cookies
               document.cookie = 'jwt=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; Secure; SameSite=Strict';
               document.cookie = 'userEmail=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; Secure; SameSite=Strict';
               document.cookie = 'demoToken=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; Secure; SameSite=Strict';
               document.cookie = 'mnemonicPhrase=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; Secure; SameSite=Strict';
            }
         } catch (error) {
            // JWT inválido, limpiar cookies
            document.cookie = 'jwt=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; Secure; SameSite=Strict';
            document.cookie = 'userEmail=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; Secure; SameSite=Strict';
            document.cookie = 'demoToken=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; Secure; SameSite=Strict';
            document.cookie = 'mnemonicPhrase=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; Secure; SameSite=Strict';
         }
      }
   }, [navigate, redirectTo]);
};

export default useAuthRedirect;